import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set to 2 hours from now
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60 + 15 * 60 + 30); // 2h 15m 30s
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col items-center justify-center my-6" data-id="element-264">
      <p className="text-red-600 font-bold mb-2 text-sm uppercase tracking-wider animate-pulse" data-id="element-265">
        ⚠️ La oferta termina en:
      </p>
      <div className="flex gap-3" data-id="element-266">
        <div className="flex flex-col items-center" data-id="element-267">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-268">
            {hours.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-269">HORAS</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-270">:</div>
        <div className="flex flex-col items-center" data-id="element-271">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-272">
            {minutes.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-273">MIN</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-274">:</div>
        <div className="flex flex-col items-center" data-id="element-275">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-276">
            {seconds.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-277">SEG</span>
        </div>
      </div>
    </div>;
}